export async function loadCreatedGptLiveConversationAndRefreshInBackground(
  createdId: number,
  getSelectedConversationId: () => string | number | null,
  loadConversation: (conversationId: number) => Promise<unknown>,
  refreshConversationList: () => Promise<unknown>,
  onAbandoned: (conversationId: number) => void,
): Promise<number | null> {
  let selected: boolean;
  if (getSelectedConversationId() !== null) {
    onAbandoned(createdId);
    selected = false;
  } else {
    await loadConversation(createdId);
    selected = true;
  }

  try {
    void refreshConversationList().catch((error: unknown) => {
      console.warn(
        "[IDA Chat] Background conversation list refresh failed:",
        error,
      );
    });
  } catch (error) {
    console.warn(
      "[IDA Chat] Background conversation list refresh failed:",
      error,
    );
  }
  return selected ? createdId : null;
}
